import FormGroup from './FormGroup';

// export types
export type { FormGroupProps } from './FormGroup';

// export hooks
export { useFormGroup } from './useFormGroup';

// export components
export { FormGroup };
export default FormGroup;
